export default "__VITE_ASSET__B55c8UId__"